import React, {Component} from "react";
import {Field, reduxForm} from "redux-form/immutable";
import ActionButton from "../../components/ActionButton";
import FormFieldsTable from "../../components/forms/FormFieldsTable";
import DateInputField from "../../components/forms/DateInputField";
import FormError from "../../components/forms/FormError";

class DateForm extends Component {

  render() {
    let {errors, handleSubmit, submit, submitting, showDatePicker, fieldLabel, fieldName} = this.props;
    let submitLabel = submitting ? "Standby..." : "Submit"; 
    return (
      <form onSubmit={handleSubmit}>
        <div className="fields">
          <FormFieldsTable>
            <Field 
              label={fieldLabel}
              name={fieldName}
              component={DateInputField}
              showDatePicker={showDatePicker}
              dateFormat="ddd D MMM, YYYY"
              serverError={this.props.errors[fieldName]}
              />
          </FormFieldsTable>
        </div>
        <FormError error={errors._error} />
        <div className="buttons">
          <ActionButton label={submitLabel} onClick={submit} active={!submitting} />
          <ActionButton label="Cancel" active={!submitting} onClick={this.props.onCancel} />
        </div>
      </form>
    )
  }
}

const ReduxForm = reduxForm({
  form: "DateForm"
})(DateForm);

export default ReduxForm;